import http from "@http"
// import env from "@api"

let API = {
     //登录接口
     LOGIN_URL:"/user/login",
    //修改密码接口
    CHANGEPAD_URL:"/user/updatePwd",
    //积分配置接口
    POINTSETTING_URL:"/user/updateExchangeConfig",
    //获取积分配置接口
    GETSETTING_URL:"/user/getExchangeConfig",
}


//登录
export function getLogin(loginInfo){
    return http.post(API.LOGIN_URL, loginInfo)
} 


// 退出登录
export function getOutLogin(loginInfo){
    return http.post(API.OUTLOGIN_URL, loginInfo)
} 

// 修改密码
export function getChangePassword(passwordForm){
    return http.post(API.CHANGEPAD_URL, passwordForm)
} 

// 积分配置
export function updatePointSetting(pointsForm){
    return http.post(API.POINTSETTING_URL, pointsForm)
} 

// 获取积分配置
export function getPointSetting(pointsForm){
    return http.post(API.GETSETTING_URL, pointsForm)
} 
